import { render, staticRenderFns } from "./ImportanceAssessmentTab.vue?vue&type=template&id=3c07575a&"
import script from "./ImportanceAssessmentTab.vue?vue&type=script&lang=js&"
export * from "./ImportanceAssessmentTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports